/**
 * HUD text (GDD §3.9, §7.2). Scores read "012 480" as on the concept board; past six digits they keep growing in
 * groups of three (judgment call 13). Values that change every frame (fuel, progress, fades) come from tables built
 * once, so updating the HUD creates no strings (GDD §10.5).
 */

/** "012 480"; "1 234 567" past six digits. */
export function formatScore(n: number): string {
  const s = String(Math.max(0, Math.floor(n))).padStart(6, '0');
  let out = '';
  for (let i = 0; i < s.length; i++) {
    if (i > 0 && (s.length - i) % 3 === 0) out += ' ';
    out += s[i];
  }
  return out;
}

/** "03": section, bridge and level numbers on the board. */
export const pad2 = (n: number): string => String(Math.max(0, Math.floor(n))).padStart(2, '0');

/** Jets in roman numerals, as the phone board's "JETS III" chip. */
const ROMAN = ['0', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
export const roman = (n: number): string => ROMAN[Math.max(0, Math.min(ROMAN.length - 1, Math.floor(n)))] ?? '0';

/** "0%" … "100%": the fuel figure and its bar width (the board's `{{fuelPct}}%` and `{{fuelW}}`). */
export const PERCENT: readonly string[] = Array.from({ length: 101 }, (_, i) => `${i}%`);

/** Fuel as the board rounds it: a whole percent, 0..100. */
export const fuelPercent = (fuel: number): number => Math.max(0, Math.min(100, Math.round(fuel * 100)));

/** Progress-bar fills in thousandths: "scaleX(0.000)" … "scaleX(1.000)". */
export const SCALE_STEPS = 1000;
export const SCALE_X: readonly string[] = Array.from(
  { length: SCALE_STEPS + 1 },
  (_, i) => `scaleX(${(i / SCALE_STEPS).toFixed(3)})`,
);

/** Opacities in hundredths: "0.00" … "1.00". */
export const OPACITY: readonly string[] = Array.from({ length: 101 }, (_, i) => (i / 100).toFixed(2));

export const clamp01 = (v: number): number => (v < 0 ? 0 : v > 1 ? 1 : v);
